import React from 'react';
import { Box } from '@mui/material';

/**
 * Hardware product image with glow effect.
 *
 * Props:
 *   image - imported image source (required)
 *   alt   - alt text (default: "SetSync Box")
 */
const HardwareBox = ({ image, alt = 'SetSync Box - Professional streaming hardware' }) => (
  <Box
    sx={{
      width: '100%',
      maxWidth: 500,
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    {/* Glow effect behind the box */}
    <Box
      sx={{
        position: 'absolute',
        width: '80%',
        height: '60%',
        background: (theme) =>
          `radial-gradient(ellipse at center, ${theme.palette.primary.main}4D 0%, transparent 70%)`,
        filter: 'blur(40px)',
        zIndex: 0,
      }}
    />
    {/* Product Image */}
    <Box
      component="img"
      src={image}
      alt={alt}
      sx={{
        width: '100%',
        height: 'auto',
        position: 'relative',
        zIndex: 1,
        filter: 'drop-shadow(0 20px 40px rgba(0, 0, 0, 0.5))',
        transition: 'transform 0.3s ease',
        '&:hover': {
          transform: 'scale(1.02)',
        },
      }}
    />
  </Box>
);

export default HardwareBox;
